import qs from 'qs'

export const getAttachmentIdsForBulkEdit = (attachmentIdsForBulkEdit: string): string[] => {
  const attachmentIdsForBulkEditParsed = qs.parse(attachmentIdsForBulkEdit) as unknown as Record<number, string>
  return Object.values(attachmentIdsForBulkEditParsed) || []
}
